import { fetchDetailsError, fetchDetailsPending, fetchDetailsSuccess } from './fetchDetailsActions';
import { DetailsDataStructure } from 'components/DetailsPageBoilerplate/types';

const exportFunc = (fetcher: () => Promise<any>) => {
  return (dispatch: any) => {
    dispatch(fetchDetailsPending());
    fetcher()
      .then((detailsRawData: DetailsDataStructure) => {
        dispatch(fetchDetailsSuccess(detailsRawData));
        return detailsRawData;
      })
      .catch((error) => {
        dispatch(fetchDetailsError('Fetching data error.'));
        console.error(error);
      });
  };
};

export default exportFunc;
